/** DEV OPTS*/
/* @flow */
/* eslint-env node*/
/* eslint-disable no-console */
/*
 * Coach Amigo React STREAM
 * https://github.com/facebook/react-native
 *
 */
import type { Props } from './../types/types';

import React from 'react';

const View = React.forwardRef((props: Props, ref: any) => {
   if (!props) props = {};
   props = {
      className: 'view',
      children: null,
      style: {},
      ...props
   };
   return (
      <div {...props} ref={ref} className={props.className} style={props.style}>
         {props.children}
      </div>
   );
});

View.displayName = 'View';

export default React.memo(View);
